"use strict";

(function () {
  uR.static = function (s) {
    return uR.config.STATIC_URL + s;
  };
  uR.config.STATIC_URL = "/static/";
})();